import { createSlice } from '@reduxjs/toolkit'
import { fetchAllCurrencies } from 'redux-thunk/thunk/currency.thunk'

const initialState = {
  currencyData: null
}

const currencySlice = createSlice({
  name: 'currencySlice',
  initialState,
  reducers: {
    setSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCurrencies.fulfilled, (state, { payload }) => {
        state.currencyData = payload
      })
  }
})

export const { setSelectedCurrency } = currencySlice.actions

export default currencySlice.reducer
